import {
  userPermissionsSubscriberSelector,
  userPermissionsSelector,
} from '@wildberries/databus-service-user';
import { ABAC_FEATURES } from '@/shared';
import { SUPPLIERS_ABAC_SCOPE, QR_SUPPLIES_FEATURE } from '../../_constants';

export const qrSuppliesShownSubscriberSelector = (data) => {
  const permissions =
    userPermissionsSubscriberSelector(SUPPLIERS_ABAC_SCOPE)(data);

  return permissions[QR_SUPPLIES_FEATURE];
};

export const canShopRequisitesSelector = () => {
  const permissions = userPermissionsSelector(SUPPLIERS_ABAC_SCOPE);

  return permissions[ABAC_FEATURES.canUseNmRequisite];
};

export const canSupplyShkStatusSelector = () => {
  return true;
  const permissions = userPermissionsSelector(SUPPLIERS_ABAC_SCOPE);

  return permissions[ABAC_FEATURES.supplyShkStatus];
};
